import { render, staticRenderFns } from "./CRUDTable2.vue?vue&type=template&id=0b1d8298"
import script from "./CRUDTable2.vue?vue&type=script&lang=js"
export * from "./CRUDTable2.vue?vue&type=script&lang=js"
import style0 from "./CRUDTable2.vue?vue&type=style&index=0&id=0b1d8298&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports